module.exports = __webpack_public_path__ + "static/media/Sec-1_Home2_CN_Mobile.ff96fcf4.png";